import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { register } from "@paths";
import { DEFAULT_EMAIL_SEARCH_PARAM } from "@utils";
import { activateUserAccountQuery } from "@query";
import { useStores } from "@hooks";
import { ActivationForm } from "@forms";
import { Alert } from "@components";
import Grid from "@material-ui/core/Grid";

export const Activate = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { userStore, stateStore } = useStores();
  const { search } = useLocation();

  const email = new URLSearchParams(search).get(DEFAULT_EMAIL_SEARCH_PARAM) || null;

  const [ alertText, setAlertText ] = useState(
    (state?.from.match(register)) && userStore.data?.email
      ? t("views.register.successful", { email: userStore.data.email })
      : ""
  );

  const activate = async (data) => {
    try {
      const userData = await activateUserAccountQuery(data);
      userStore.saveUserData(userData);
      userStore.checkWorkspacesAndRedirect();
      userStore.setLoginProcessStatus(true);
    } catch (e) {
      if (e.response) setAlertText(e.response.data.error);
      else setAlertText(t("errors.network"));
    }
  };

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      wrap="nowrap"
      className="mt-3"
    >
      <Grid item container>
        <ActivationForm
          onSubmit={activate}
          defaultEmail={stateStore.activationEmail || email}
        />
      </Grid>
      <Alert
        isOpen={Boolean(alertText)}
        title={alertText}
        acceptText={t("common.close")}
        onAccept={() => setAlertText("")}
      />
    </Grid>
  );
};
